export default __webpack_public_path__ + "svg/calendar/2025/9/diciembre.svg?8508b9e7";